import {EntityService} from "../entity-service"
import {Shipnotify} from "@/model/entity/shipnotify/shipnotify"
import {AxiosPromise} from "axios"

class ShipnotifyService extends EntityService<Shipnotify> {

  constructor() {
    super("shipnotify", Shipnotify)
  }

  getOfficeNames(shipnotifyId: number) {
    return this.$http.get(this.path + "/offices/" + shipnotifyId)
  }

  geodata(parcelIds: number[]) {
    let queryPath = this.path + "/geodata" + "?"
    parcelIds.forEach(id => (queryPath += "parcelId=" + id + "&"))
    return this.$http({
      method: "get",
      url: queryPath,
      responseType: "arraybuffer"
    })
  }
}

export interface IShipnotifyService extends EntityService<Shipnotify> {
  getOfficeNames(shipnotifyId: number): AxiosPromise<string[]>

  geodata(parcelIds: number[]): AxiosPromise

}

const service = new ShipnotifyService()

export const shipnotifyService = service
